import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=4ae84f70&scoped=true"
import script from "./CallUs.vue?vue&type=script&lang=js"
export * from "./CallUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae84f70",
  null
  
)

export default component.exports